var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup427320178(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78764 9H16.6305C16.7869 9.00066 16.9396 9.04768 17.0693 9.13513C17.199 9.22258 17.2999 9.34653 17.3592 9.4913C17.4184 9.63607 17.4334 9.79516 17.4023 9.94846C17.3711 10.1018 17.2952 10.2424 17.1841 10.3525L12.7706 14.766C12.6971 14.8402 12.6096 14.899 12.5132 14.9392C12.4169 14.9793 12.3135 15 12.2091 15C12.1046 15 12.0013 14.9793 11.9049 14.9392C11.8085 14.899 11.721 14.8402 11.6475 14.766L7.23397 10.3525C7.1229 10.2424 7.04699 10.1018 7.01584 9.94846C6.98469 9.79516 6.99969 9.63607 7.05896 9.4913C7.11822 9.34653 7.21908 9.22258 7.34878 9.13513C7.47849 9.04768 7.63121 9.00066 7.78764 9Z",
    fill: "#F26639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427320178);
export default __webpack_public_path__ + "static/media/Group 427320178.6c014f16d1704aa9a5afd3e71896af85.svg";
export { ForwardRef as ReactComponent };